<template>
  <v-dialog
    ref="dialog"
    v-model="modal"
    :return-value.sync="date"
    persistent
    lazy
    full-width
    width="290px"
  >
    <template v-slot:activator="{ on }">
      <form-input :name="name" :onChanged="changed" :title="title" @focus="modal = true"></form-input>
    </template>
    <v-date-picker v-model="item[name]" :min="minDate" first-day-of-week="1" locale="ru" scrollable>
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">Отмена</v-btn>
      <v-btn flat color="primary" @click="saveDate">OK</v-btn>
    </v-date-picker>
  </v-dialog>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/edit-form/new-items/Input'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')
  export default {
    name: 'Calendar',
    data () {
      return {
        date: new Date().toISOString().substr(0, 10),
        modal: false,
        changed: false

      }
    },
    props: ['name', 'min', 'title'],
    computed: {
      ...mapState([
        'item'
      ]),
      minDate () {
        if (this.min) {
          return this.item[this.min]
        }
      }
    },
    methods: {
      ...mapMutations([
        'setField'
      ]),
      saveDate() {
        this.$refs.dialog.save(this.date)
        this.changed = true
      },
      hide () {
        this.$emit('close')
      },
      isValidDate (date) {
        return date instanceof Date && !isNaN(date.getTime())
      }
    },
    components: {
      FormInput
    }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/edit-form/Calendar.vue